export default __webpack_public_path__ + "static/media/Img131.9a40aeb7.jpg";